import { MarketsWrapNewsArticle } from "~types/types";
import { extractMarketMoves } from "~utils/marketWrapUtils";

export const fetchMarketWrapNews = async (sectionFrontName: string) => {
  const marketsWrapNewsApi = `/bazaar/api/markets-wrap/markets-wrap-news`;

  const response = await fetch(marketsWrapNewsApi);

  if (!response.ok) {
    console.error("Failed to fetch Markets Wrap news:", response.status);

    return null;
  }

  // Single markets wrap article
  const payload: MarketsWrapNewsArticle = await response.json();

  // extract Main Movers in the market
  const mainMoves = extractMarketMoves(payload.body.text, sectionFrontName);

  // Hydrate `updatedAt` into a Date
  return {
    ...payload,
    updatedAt: new Date(payload.updatedAt),
    mainMoves,
  };
};
